import { I18nProvider } from '@lingui/react';
import React from 'react';
import { defaultLocale, load } from './i18n.config';

export default function ExtendedI18nProvider({
  i18n,
  locale,
  children,
  ...rest
}) {
  React.useEffect(() => {
    async function loadLocale() {
      await load(locale);
      i18n.activate(locale);
    }
    loadLocale();
  }, [locale]);
  if (!locale) console.log('locale is undefined', rest);
  i18n._locale = locale || defaultLocale;

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
